import { render, staticRenderFns } from "./Permit.vue?vue&type=template&id=1adf737f&scoped=true"
import script from "./Permit.vue?vue&type=script&lang=js"
export * from "./Permit.vue?vue&type=script&lang=js"
import style0 from "./Permit.vue?vue&type=style&index=0&id=1adf737f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf737f",
  null
  
)

export default component.exports